var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"vue-qz-tray--input--iframe",attrs:{"src":"about:blank"},on:{"load":_vm.updateIframe}})}
var staticRenderFns = []

export { render, staticRenderFns }